module.exports = __webpack_public_path__ + "assets/preorder-cart.cd6d8294.svg";